import {
  GlobalGroupProducts,
  GroupAttributeCodeOptionDependency,
  GroupAttributeCodeSetSource,
  GroupParentAttributeOptionSet,
} from "@/components/configurator/global-option/types";
import store from "@/utils/storage-manager/index";
import Serialize from "@/utils/serialize";
import Deserialize from "@/utils/deserialize";

export type GlobalOptionsResources = {
  defaultGlobalOptions?: string;
  selectedGlobalOptions?: string;
  globalGroupProducts?: string;
  groupAttributeCodeOptionDependency?: string;
  grouoAttributeCodeSetSource?: string;
};

const KEY = "GLOBAL_OPTION_RESOURCES";

const create = (data: GlobalOptionsResources = {}) => {
  remove();
  const globalOptionResources = {
    defaultGlobalOptions: data.defaultGlobalOptions ?? "",
    selectedGlobalOptions: data.selectedGlobalOptions ?? "",
    globalGroupProducts: data.globalGroupProducts ?? "",
    groupAttributeCodeOptionDependency:
      data.groupAttributeCodeOptionDependency ?? "",
    grouoAttributeCodeSetSource: data.grouoAttributeCodeSetSource ?? "",
  };
  store.set(KEY, globalOptionResources);
};

const setGlobalGroupResources = (data: GlobalOptionsResources): void => {
  store.set(KEY, data);
};
const get = () => {
  return store.get(KEY);
};

const remove = () => {
  store.omit(KEY);
};

const setDefaultOptions = (data: GroupParentAttributeOptionSet): void => {
  const globalOptionsResources = get();
  const serializedData = Serialize.groupParentAttributeOptionSet(data);
  if (!globalOptionsResources) {
    create({
      defaultGlobalOptions: serializedData,
    });
  } else {
    globalOptionsResources.defaultGlobalOptions = serializedData;
    setGlobalGroupResources(globalOptionsResources);
  }
};

const setSelectedOptions = (data: GroupParentAttributeOptionSet): void => {
  const globalOptionsResources = get();
  const serializedData = Serialize.groupParentAttributeOptionSet(data);
  if (!globalOptionsResources) {
    create({
      selectedGlobalOptions: serializedData,
    });
  } else {
    globalOptionsResources.selectedGlobalOptions = serializedData;
    setGlobalGroupResources(globalOptionsResources);
  }
};

const setGlobalGroupProducts = (data: GlobalGroupProducts): void => {
  const globalOptionsResources = get();
  const serializedData = Serialize.globalGroupProducts(data);
  if (!globalOptionsResources) {
    create({
      globalGroupProducts: serializedData,
    });
  } else {
    globalOptionsResources.globalGroupProducts = serializedData;
    setGlobalGroupResources(globalOptionsResources);
  }
};

const setGroupAttributeCodeOptionDependency = (
  data: GroupAttributeCodeOptionDependency,
): void => {
  const globalOptionsResources = get();
  const serializedData = Serialize.groupAttributeCodeOptionDependency(data);
  if (!globalOptionsResources) {
    create({
      groupAttributeCodeOptionDependency: serializedData,
    });
  } else {
    globalOptionsResources.groupAttributeCodeOptionDependency = serializedData;
    setGlobalGroupResources(globalOptionsResources);
  }
};

const setGroupAttributeCodeSetSource = (data: GroupAttributeCodeSetSource) => {
  const globalOptionsResources = get();
  const serializedData = Serialize.groupAttributeCodeSetSource(data);
  if (!globalOptionsResources) {
    create({
      grouoAttributeCodeSetSource: serializedData,
    });
  } else {
    globalOptionsResources.grouoAttributeCodeSetSource = serializedData;
    setGlobalGroupResources(globalOptionsResources);
  }
};

const getDefaultOptions = (): GroupParentAttributeOptionSet | undefined => {
  const globalOptionsResources = get();
  if (!globalOptionsResources) return undefined;
  return Deserialize.groupParentAttributeOptionSet(
    globalOptionsResources.defaultGlobalOptions,
  );
};

const getSelectedOptions = (): GroupParentAttributeOptionSet | undefined => {
  const globalOptionsResources = get();
  if (!globalOptionsResources) return undefined;
  return Deserialize.groupParentAttributeOptionSet(
    globalOptionsResources.selectedGlobalOptions,
  );
};

const getGlobalGroupProducts = (): GlobalGroupProducts | undefined => {
  const globalOptionsResources = get();
  if (!globalOptionsResources) return undefined;
  return Deserialize.globalGroupProducts(
    globalOptionsResources.globalGroupProducts,
  );
};

const getGroupAttributeCodeOptionDependency = ():
  | GroupAttributeCodeOptionDependency
  | undefined => {
  const globalOptionsResources = get();
  if (!globalOptionsResources) return undefined;
  return Deserialize.groupAttributeCodeOptionDependency(
    globalOptionsResources.groupAttributeCodeOptionDependency,
  );
};

const getGroupAttributeCodeSetSource = ():
  | GroupAttributeCodeSetSource
  | undefined => {
  const globalOptionsResources = get();
  if (!globalOptionsResources) return undefined;
  return Deserialize.groupAttributeCodeSetSource(
    globalOptionsResources.grouoAttributeCodeSetSource,
  );
};



export const globalOptionResources = {
  remove,
  setDefaultOptions,
  setSelectedOptions,
  setGlobalGroupProducts,
  setGroupAttributeCodeOptionDependency,
  setGroupAttributeCodeSetSource,
  getDefaultOptions,
  getSelectedOptions,
  getGlobalGroupProducts,
  getGroupAttributeCodeOptionDependency,
  getGroupAttributeCodeSetSource, 
};
